import { Component, OnInit } from '@angular/core';
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PurshaseServiceDetailsComponent } from '../purshase-service-details/purshase-service-details.component';
import { purshaseService } from '../purshase.service';
import { serviceModel } from '../service-model';

@Component({
  selector: 'app-purshases-service-list',
  templateUrl: './purshases-service-list.component.html',
  styleUrls: ['./purshases-service-list.component.scss']
})
export class PurshasesServiceListComponent implements OnInit {
  purshaseServices: serviceModel[];
  private _subject$: Subject<boolean> = new Subject();
  public selectedPurshaseService : serviceModel = null;
  constructor(private dialogService: DialogService,
    private purshaseService: purshaseService) { }

  ngOnInit() {
    this.getPurshasesService();
  }

  openDetails() { 
    if(this.selectedPurshaseService != null)
    this.purshaseService
          .getOneById(this.selectedPurshaseService.itmId)
          .pipe(takeUntil(this._subject$))
          .subscribe((data : any) => {
            this.selectedPurshaseService = data;
            this.openDialog(this.selectedPurshaseService);
            this.selectedPurshaseService = null;
          });     
  }

  onCellClick($event) {
    this.selectedPurshaseService = $event.dataItem
  } 

  getPurshasesService(){
    this.purshaseService
    .getAll()
    .pipe(takeUntil(this._subject$))
    .subscribe((data:any) => {
      this.purshaseServices = data;
    });
    
  }

  openDialog(selectedPurshaseService){
    const dialogRef = this.dialogService.open({
      minWidth: "700px",
      content: PurshaseServiceDetailsComponent,
    });
    dialogRef.content.instance.selectedPurshaseService = selectedPurshaseService;
    dialogRef.result.subscribe((r:any) => {
      if ((r instanceof DialogCloseResult)!= null) {
         this.getPurshasesService();
      }
      this.selectedPurshaseService = null;
    });
  }
}
